export const GET_LINES_SUCCESS   = "GET_LINES_SUCCESS";
export const GET_LINES_ERROR     = "GET_LINES_ERROR";
export const GET_LINES_REQUEST   = "GET_LINES_REQUEST";
export const CREATE_LINE_SUCCESS = "CREATE_LINE_SUCCESS";
export const CREATE_LINE_ERROR   = "CREATE_LINE_ERROR";